import { CHANGE_CHECKED } from "../actions/type";

const initialState = {
  checked: ["background-layer", 'background-diachinh','background-SoNha']
};

const mapLayersPopup = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_CHECKED: {
      return {
        ...state,
        checked: action.payload,
      };
    }
    

    default:
      return state;
  }
};



export default mapLayersPopup;


